


























































import { Component, Vue } from 'vue-property-decorator';
import BlueHeroBanner from '~/components/UIComponents/BlueHeroBanner.vue';
import oneTreePlantedQualifyingOrders from '~/queries/oneTreePlantedQualifyingOrders.gql';

@Component({
  components: {
    BlueHeroBanner,
  },
})
export default class TreesPlantedHeader extends Vue {
  treesPlantedTotal = 0;
  treeDisplayNumber = 0;
  countAnimationIncrement = 0;
  isTreeCountLoading = false;
  hasTreeCountStarted = false;
  treeCountWidth = '';
  hasWindowResized = false;
  characterWidthChangeBuffer = 0;

  async mounted() {
    this.treesPlantedTotal = await this.fetchOneTreePlantedCount();
    this.treeDisplayNumber = this.treesPlantedTotal;

    this.$nextTick(() => {
      // Setting the initial "trees planted" number width lets us hold space in the header text
      // for the eventual number that will display once the animation completes.
      // If we don't hold this space, the header text bounces all over the place while the initial number animation is running.
      const treeCountSpan = <HTMLInputElement>this.$refs['tree-count'];

      // This width change buffer amount is needed to account for the fact that as the number count animates, some number character widths
      // make it so a given increment number may actually be wider than the final number. Without this buffer, we still get minor text jostling.
      const widthPercentage = this.treeDisplayNumber < 1000 ? 0.2 : 0.1;
      this.characterWidthChangeBuffer = Math.floor(
        treeCountSpan.clientWidth * widthPercentage,
      );

      this.treeCountWidth =
        treeCountSpan.clientWidth + this.characterWidthChangeBuffer + 'px';

      // When a user changes the window size, we need remove the extra buffer space added to the tree count.
      window.addEventListener('resize', this.updateResizeStatus);

      this.animateTreeCount(this.treesPlantedTotal);
    });
  }

  destroyed() {
    window.removeEventListener('resize', this.updateResizeStatus);
  }

  async fetchOneTreePlantedCount() {
    try {
      const oneTreePlantedCount = await this.$apollo.query<{
        oneTreePlantedQualifyingOrders: number;
      }>({
        query: oneTreePlantedQualifyingOrders,
        fetchPolicy: 'no-cache',
      });

      return oneTreePlantedCount.data &&
        oneTreePlantedCount.data.oneTreePlantedQualifyingOrders
        ? oneTreePlantedCount.data.oneTreePlantedQualifyingOrders
        : 0;
    } catch (error) {
      this.$sentry.captureException(error);
      console.warn(error);
      return 0;
    }
  }

  updateResizeStatus() {
    if (!this.hasWindowResized) {
      this.hasWindowResized = true;
    }
  }

  animateTreeCount(treesPlantedTotal: number) {
    this.hasTreeCountStarted = true;

    // Don't increment if tree count is 0
    if (treesPlantedTotal) {
      const countIncrements = [];
      let treeCount = 0;
      this.isTreeCountLoading = true;
      this.countAnimationIncrement = Math.floor(this.treesPlantedTotal / 20);

      while (treeCount < treesPlantedTotal - this.countAnimationIncrement) {
        treeCount += this.countAnimationIncrement;
        countIncrements.push(treeCount);
      }

      countIncrements.push(this.treesPlantedTotal);

      this.animateAddUp(countIncrements);
    }
  }

  animateAddUp(countIncrements: number[]) {
    // Interval repeats until all count increments have been displayed
    const countInterval = setInterval(() => {
      let currentCount = countIncrements.shift();

      if (currentCount === undefined) {
        this.isTreeCountLoading = false;
        clearInterval(countInterval);
      } else {
        this.treeDisplayNumber = currentCount;
      }
    }, 50);
  }
}
